import { sortDestinationIdFormat } from "@redotech/redo-ids-cockroach";
import {
  SortDestinationColor,
  SortDestinationColorSchema,
} from "@redotech/redo-model/wms/schema/sort-destination";
import { SortDispositionSchema } from "@redotech/redo-model/wms/schema/sort-disposition";
import * as z from "zod";

export const createSortDestination = {
  name: "createSortDestination" as const,
  input: z.object({
    name: z.string(),
    disposition: SortDispositionSchema,
    color: SortDestinationColorSchema.default(SortDestinationColor.white),
  }),
  output: z.object({ id: sortDestinationIdFormat.schema }),
};
